import React from "react";
import { Outlet, useLoaderData } from "react-router-dom";
import TabLayout from "../../../helpers/TabLayout";

const AnnouncementLayout = () => {
  const { announcement } = useLoaderData();
  return (
    <>
      <TabLayout
        headerLabel={announcement.label || "Announcement"}
        skeletonLines={14}
      >
        <Outlet/>
      </TabLayout>
    </>
  );
};

export default AnnouncementLayout;